<template>
    <div>
        <h1>Boas vindas ao Astandes!</h1>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Home.vue